import * as Styled from './styled'

interface IToggleSwitcherOption {
  value: string
  label: string
}

interface IToggleSwitcherProps {
  value: string
  onChange: (value: string) => void
  options: IToggleSwitcherOption[]
  label?: string
}

export const ToggleSwitcher = ({
  value,
  onChange,
  options,
  label
}: IToggleSwitcherProps) => {
  return (
    <Styled.ToggleContainer>
      {label && <Styled.Label>{label}</Styled.Label>}
      <Styled.SwitchWrapper>
        {options.map(option => (
          <Styled.SwitchOption
            key={option.value}
            $isActive={value === option.value}
            onClick={() => onChange(option.value)}
            type="button"
          >
            {option.label}
          </Styled.SwitchOption>
        ))}
      </Styled.SwitchWrapper>
    </Styled.ToggleContainer>
  )
}
